import { render, staticRenderFns } from "./WYSIWYGInput.vue?vue&type=template&id=147f5bb9"
import script from "./WYSIWYGInput.vue?vue&type=script&lang=js"
export * from "./WYSIWYGInput.vue?vue&type=script&lang=js"
import style0 from "./WYSIWYGInput.vue?vue&type=style&index=0&id=147f5bb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports